var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgPopout(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    id: "popout_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    xmlSpace: "preserve"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    className: "popout_svg__st0",
    d: "M19 11h-1V3c0-1.7-1.3-3-3-3H3C1.4 0 0 1.3 0 3v8c0 1.7 1.3 3 3 3h4v5c0 .6.4 1 1 1h11c.6 0 1-.4 1-1v-7c0-.6-.4-1-1-1zm-2 0H8c-.6 0-1 .4-1 1v1H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v8z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    className: "popout_svg__st0",
    d: "M8.5 4c-.3 0-.5.2-.5.5v2.8L3.4 2.6c-.2-.2-.5-.2-.7 0s-.2.5 0 .7L7.3 8H4.5c-.3 0-.5.2-.5.5s.2.5.5.5h3C8.3 9 9 8.3 9 7.5v-3c0-.3-.2-.5-.5-.5z"
  })));
}
export default SvgPopout;